module.exports = __webpack_public_path__ + "static/media/notes-icon.7781e188.svg";